import PropTypes from 'prop-types';
import React from 'react';

import { Alert, Box, Dialog, DialogContent, DialogTitle, Typography } from 'components/AORedesign';
import { componentIdStringGenerator } from 'helpers';
import NewsArticlesSkeleton from './NewsArticlesSkeleton';

// DialogTitle derives its DOM id from these two values, so build the matching id the same way
const TITLE_ID = 'news-review-modal-title';
const DESCRIPTION_ID = 'news-review-modal-description';
const TITLE_DOM_ID = componentIdStringGenerator('DialogTitle', TITLE_ID);

const NewsArticleModal = ({ open, handleClose, loading, error, data }) => {
  const renderContent = () => {
    if (loading) {
      return <NewsArticlesSkeleton />;
    }
    if (error) {
      return <Alert severity="error">{error.message}</Alert>;
    }
    return <Box>{data?.txt && <Typography>{data.txt}</Typography>}</Box>;
  };

  // only render (and reference) the title once the article has one
  const showTitle = !loading && !error && Boolean(data?.title);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby={showTitle ? TITLE_DOM_ID : undefined}
      PaperProps={showTitle ? undefined : { 'aria-label': 'News article' }}
      aria-describedby={DESCRIPTION_ID}>
      {showTitle && (
        <DialogTitle id={TITLE_ID}>
          <Typography variant="h5" component="span">
            {data.title}
          </Typography>
        </DialogTitle>
      )}
      <DialogContent id={DESCRIPTION_ID} style={{ paddingBottom: 24 }}>
        {renderContent()}
      </DialogContent>
    </Dialog>
  );
};

NewsArticleModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.object,
  data: PropTypes.shape({
    title: PropTypes.string,
    txt: PropTypes.string,
  }),
};

export default NewsArticleModal;
